import React from 'react';
import { useWebsocket } from '../hooks/socket/useWebsocket';
import {
  UserWebSocketContext,
  CustomerWebSocketContext,
} from '../contexts/auth.contexts';
import { getTokenManager } from '../config/tokenManager';

interface WebSocketProviderProps {
  children: React.ReactNode;
}

export const UserWebSocketProvider: React.FC<WebSocketProviderProps> = ({
  children,
}) => {
  const { subscribe, joinRoom, leaveRoom, socket } = useWebsocket({
    authType: 'user',
    getAuthTokens: () => {
      const tokens = getTokenManager().getUserTokens();
      return {
        accessToken: tokens.accessToken || null,
        refreshToken: tokens.refreshToken || null,
      };
    },
    setAuthTokens: (tokens) => getTokenManager().setUserTokens(tokens),
  });

  return (
    <UserWebSocketContext.Provider
      value={{
        subscribe,
        joinRoom,
        leaveRoom,
        socket,
        isConnected: socket?.connected ?? false,
      }}
    >
      {children}
    </UserWebSocketContext.Provider>
  );
};

export const CustomerWebSocketProvider: React.FC<
  WebSocketProviderProps & { businessId?: string; enabled?: boolean }
> = ({ children, businessId = '', enabled = false }) => {
  const { subscribe, joinRoom, leaveRoom, socket } = useWebsocket({
    authType: 'customer',
    getAuthTokens: () => {
      const tokens = getTokenManager().getCustomerTokens(businessId);
      return {
        accessToken: tokens.accessToken || null,
        refreshToken: tokens.refreshToken || null,
      };
    },
    setAuthTokens: (tokens) =>
      getTokenManager().setCustomerTokens(businessId, tokens),
    enabled,
  });

  return (
    <CustomerWebSocketContext.Provider
      value={{
        subscribe,
        joinRoom,
        leaveRoom,
        socket,
        isConnected: socket?.connected ?? false,
      }}
    >
      {children}
    </CustomerWebSocketContext.Provider>
  );
};
